import { render } from "./infoRefuge.vue?vue&type=template&id=37f6d75c"
import script from "./infoRefuge.vue?vue&type=script&lang=js"
export * from "./infoRefuge.vue?vue&type=script&lang=js"

import "./infoRefuge.vue?vue&type=style&index=0&id=37f6d75c&lang=css"
import "../assets/css/besoins.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__